<template>
  <v-container fill-height
    ><v-row align="center" justify="center">
      <v-col cols="8"
        ><v-card>
          <v-row class="justify-center">
            <v-col cols="12">
              <div class="inactive">
                Your subscription appears to be inactive. Please contact
                <a href="mailto:rchubb@colourspectrums.com">ColourSpectrums</a>
                to subscribe.
                <v-card-text>
                  email: <a href="mailto:rchubb@colourspectrums.com">rchubb@colourspectrums.com</a> <br />
                  phone: 780-300-3030<br />
                  website: <a href="https://www.colourspectrums.com">ColourSpectrums.com</a></v-card-text
                >
              </div>
            </v-col>
          </v-row>
        </v-card></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
.inactive {
  font-size: 1.3em;
  padding: 50px;
}
</style>
